import { useEffect, useState } from "react";
import { ticketQueue } from "..";
import type { TicketPrintJob } from "../ticket-queue";

/**
 * The failure notice (T018, T019, FR-214, FR-215).
 *
 * A BANNER, NOT A MODAL. Unlike the void alert or the manual-open prompt, a
 * failed ticket must never block the till (FR-212) — the cashier needs to
 * keep ringing sales while a printer problem gets fixed, so this sits
 * alongside the till rather than over it.
 *
 * NAMES THE CAUSE WHERE THE TRANSPORT REPORTS ONE (FR-214). Reuses the same
 * FailureCode vocabulary the drawer already uses — a ticket fails for the
 * same hardware reasons a kick does.
 */

const CAUSE_TEXT: Record<string, string> = {
  permission_lost: "The printer needs to be reconnected in settings.",
  device_disconnected: "The printer isn't responding. Check the cable or that it's on.",
  unsupported_browser: "This device can't print tickets.",
  kick_timeout: "The ticket didn't print.",
};

function causeText(job: TicketPrintJob): string {
  if (job.state === "stale") {
    return "This ticket sat too long without printing and was set aside.";
  }
  return (job.lastError && CAUSE_TEXT[job.lastError]) ?? "The ticket didn't print.";
}

export function TicketFailureNotice() {
  const [jobs, setJobs] = useState<readonly TicketPrintJob[]>(ticketQueue.jobs);

  useEffect(() => ticketQueue.subscribe(setJobs), []);

  const unresolved = jobs.filter((job) => job.state === "failed" || job.state === "stale");
  if (unresolved.length === 0) return null;

  return (
    <div className="ticketfailure" role="status">
      {unresolved.map((job) => (
        <div key={job.opId} className="ticketfailure__row">
          <span className="ticketfailure__text">
            Order {job.document.orderNumber || "—"}: {causeText(job)}
          </span>
          <button
            type="button"
            className="ticketfailure__retry"
            onClick={() => void ticketQueue.retry(job.opId)}
          >
            Retry
          </button>
        </div>
      ))}
    </div>
  );
}

export default TicketFailureNotice;
